<template>
  <div>
    <div class="items">
      <div class="item card-white">
        <!-- :class="{ 'margin-200-top': status.complete } -->

        <div class="card" v-if="!status.complete">
          <eyebrow-icon
            v-if="true"
            v-bind:eyebrowicon="{ icon: 'star-outline', color: 'black' }"
            v-bind:align="'center'"
          ></eyebrow-icon>
          <h4 class="pr-title-form">
            Share your feedback on {{ this.acf.model }}
          </h4>
        </div>

        <form
          id="ContactForm"
          ref="contact_form"
          class="contact-form"
          action="javascript:"
          v-on:submit.prevent="submit"
        >
          <div v-if="!status.complete">
            <!-- stars rating -->
            <starRating></starRating>

            <div class="group">
              <label for="userLength"
                >How long have you been using your CPAP machine?</label
              >
              <select
                class="validation selectOptGroup"
                id="userLength"
                v-bind:class="{ '-invalid': validation.userLength }"
                v-model="fields.userLength"
                @change="updateUserLength()"
              >
                <option selected disabled value="">
                  Select from the following options...
                </option>
                <option value="Less than a year">Less than a year</option>
                <option value="1 – 2 years">1 – 2 years</option>
                <option value="3 – 4 years">3 – 4 years</option>
                <option value="5+ years">5+ years</option>
              </select>
              <div
                class="error-message"
                v-for="message in validation.userLength"
              >
                {{ message }}
              </div>
            </div>

            <div class="group">
              <label for="recommendProduct"
                >Do you regularly replace your CPAP machine accessories -- the
                air filters, humidifier tub and tubing?</label
              >

              <label class="check container-radio" for="yes"
                >Yes
                <input
                  type="radio"
                  id="yes"
                  name="replacementFrequency"
                  v-model="fields.replacementFrequency"
                  value="yes"
                  @change="validation.replacementFrequency = null"
                />
                <span class="checkmark"></span>
              </label>

              <label class="check container-radio" for="no"
                >No
                <input
                  type="radio"
                  id="no"
                  name="replacementFrequency"
                  v-model="fields.replacementFrequency"
                  value="no"
                  @change="validation.replacementFrequency = null"
                />
                <span class="checkmark"></span>
              </label>

              <div
                class="error-message only-text"
                v-for="message in validation.replacementFrequency"
              >
                {{ message }}
              </div>
            </div>

            <div class="group">
              <label for="climateLineAir"
                >Have you tried our ClimateLineAir heated tubing for
                humidification?</label
              >

              <label class="check check container-radio" for="yes_1"
                >Yes
                <input
                  type="radio"
                  id="yes_1"
                  name="climateLineAir"
                  v-model="fields.climateLineAir"
                  value="yes"
                  @change="validation.climateLineAir = null"
                />
                <span class="checkmark"></span>
              </label>

              <label class="check check container-radio" for="no_1"
                >No
                <input
                  type="radio"
                  id="no_1"
                  name="climateLineAir"
                  v-model="fields.climateLineAir"
                  value="no"
                  @change="validation.climateLineAir = null"
                />
                <span class="checkmark"></span>
              </label>

              <div
                class="error-message only-text"
                v-for="message in validation.climateLineAir"
              >
                {{ message }}
              </div>
            </div>

            <h5>Please leave your review</h5>
            <div class="card-container">
              <div class="card-title">
                <img src="@/assets/images/info-solid.svg" class="info-svg" />
                <span class="s-title"
                  >When writing a review please refrain from:
                </span>
              </div>
              <div class="card-message">
                <div class="item-message">
                  1. Directly naming other companies or products good or bad.
                </div>
                <div class="item-message">
                  2. Using inappropriate or profane language.
                </div>
                <div class="item-message">
                  3. Disclosing personally identifiable information.
                </div>
              </div>
            </div>
            <br />

            <div class="group">
              <label for="recommendProduct"
                >Would you recommend this machine to other CPAP users?</label
              >

              <label class="check container-radio" for="yes_3"
                >Yes
                <input
                  type="radio"
                  id="yes_3"
                  name="recommendProduct"
                  v-model="fields.recommendProduct"
                  value="yes"
                  @change="validation.recommendProduct = null"
                />
                <span class="checkmark"></span>
              </label>

              <label class="check container-radio" for="no_3"
                >No
                <input
                  type="radio"
                  id="no_3"
                  name="recommendProduct"
                  v-model="fields.recommendProduct"
                  value="no"
                  @change="validation.recommendProduct = null"
                />
                <span class="checkmark"></span>
              </label>

              <div
                class="error-message only-text"
                v-for="message in validation.recommendProduct"
              >
                {{ message }}
              </div>
            </div>

            <div class="group">
              <label for="reviewTitle">Review title</label>
              <input
                type="text"
                class="validation"
                id="reviewTitle"
                placeholder="Add a title (max 35 characters)"
                v-bind:class="{ '-invalid': validation.reviewTitle }"
                v-model="fields.reviewTitle"
                v-on:keyup="validation.reviewTitle = null"
                maxlength="35"
              />
              <div
                class="error-message"
                v-for="message in validation.reviewTitle"
              >
                {{ message }}
              </div>
            </div>

            <div class="group">
              <label for="reviewDescription">Review</label>
              <textarea
                class="validation"
                id="reviewDescription"
                placeholder="Please write your review here (min 50 characters)"
                v-bind:class="{ '-invalid': validation.reviewDescription }"
                v-model="fields.reviewDescription"
                v-on:keyup="validation.reviewDescription = null"
              ></textarea>
              <div
                class="error-message"
                v-for="message in validation.reviewDescription"
              >
                {{ message }}
              </div>
            </div>

            <!-- firstname -->
            <firstname></firstname>

            <!-- lastname -->
            <lastname></lastname>

            <!-- email and phone -->
            <email></email>

            <!-- select: country -->
            <country></country>

            <!-- select: satate -->
            <component :is="states[fields.country]"></component>

            <!-- checkbox: feedbackConcent -->
            <feedbackConsent></feedbackConsent>

            <!-- checkbox: marketing_oncent -->
            <marketingConsent></marketingConsent>

            <!-- submit, validation and confirmation -->
            <submit-confirmation></submit-confirmation>

            <input
              type="hidden"
              name="deviceModel"
              v-model="fields.deviceModel"
            />
            <input
              type="hidden"
              name="deviceBrand"
              v-model="fields.deviceBrand"
            />
            <input
              type="hidden"
              name="timeOnMachineDatestamp"
              v-model="fields.timeOnMachineDatestamp"
            />
          </div>
        </form>
        <thankyou-message v-if="status.complete"></thankyou-message>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from "./mixin.js";
let fillable = {
  starRating: "",
  userLength: "",
  replacementFrequency: "",
  climateLineAir: "",
  recommendProduct: "",
  reviewTitle: "",
  reviewDescription: "",
  firstname: "",
  lastname: "",
  email: "",
  country: "",
  state: "",
  feedbackConsent: "",
  marketing_consent: true,
  referrer: window.location.pathname,
  b2c: "yes",
  b2b: "no",
  yes_Rating: true,
  no_Rating: false,
  deviceBrand: "",
  deviceModel: "",
  deviceBrandProductRegistration: "",
  timeOnMachineDatestamp: "",
  marketingConsentDate: new Date().toISOString(),
};

export default {
  data() {
    return {
      form: {
        name: "", // form name
        origin: "", // form origin ( page )
      },
      status: {
        idle: null,
        step: [],
        last_step: [],
        errors: false,
        complete: false,
      },
      response: {
        type: "", // validation or confirmation
        message: "", // response
      },
      holdingValue: {},
      fields: { ...fillable },
      userLengthRequired: true,
      sendTimeOnMachineDatestamp: true,
      validation: {},
      states: {
        "United States": "stateUS",
        Canada: "stateCA",
      },
    };
  },
  methods: {
    updateUserLength() {
      this.validation.userLength = null;
    },
  },
  mixins: [mixin],
};
</script>
